// @flow
const titles = {
  entrar: "MudeyPRO | Entrar",
  registar: "MudeyPRO | Registar",
  restore: "MudeyPRO | Nova Password",
  configuracoes: "MudeyPRO | Configurações",
  "recuperar-pass": "MudeyPRO | Recuperação Password",
  seguros: "MudeyPRO | Seguros",
  simulações: "MudeyPRO | Simulações",
  "seguros-details": "MudeyPRO | Detalhe Apólice",
  "apolice-detalhes": "MudeyPRO | Detalhe Apólice",
  "cotar-seguros": "MudeyPRO | Seleção Produto",
  "home" : "MudeyPRO | Seguros | Página Inicial",
  "ferramentas" : "MudeyPRO | Ferramentas",
  "seguro-carro-empresas-detalhes":"MudeyPRO | Detalhes apólice",
  "recuperar-nif": "MudeyPRO | Recuperação NIF",
  "formulario-adesao": "MudeyPRO | Formulário Adesão",
  "formulario-assinatura": "MudeyPRO | Formulário Assinatura",
  "formulario-submetido": "MudeyPRO | Formulário Submetido",
  "seguro-viagem-detalhes": "MudeyPRO | Seguro Viagem | Detalhes",
  "seguro-vida-detalhes": "MudeyPRO | Seguro Vida Proteção | Detalhes",
  "seguro-vida-credito-detalhes": "MudeyPRO | Vida Crédito | Detalhes",
  "seguro-carro-detalhes": "MudeyPRO | Seguro Auto | Detalhes",
  "seguro-carro-jap-detalhes": "MudeyPRO | Seguro Auto | Detalhes",
  "seguro-moto-detalhes": "MudeyPRO | Seguro Moto | Detalhes",
  "seguro-acidentes-trabalho-independente-detalhes":
    "MudeyPRO | Seguro AT | Detalhes",
  "seguro-empregada-detalhes":
    "MudeyPRO | Emp. Doméstica | Detalhes",
  "seguro-outro-detalhes": "MudeyPRO | Seguro Outro | Detalhes",
  "seguro-casa-detalhes": "MudeyPRO | Seguro Casa | Detalhes",
  "seguro-saúde-detalhes": "MudeyPRO | Seguro Saúde | Detalhes",
  seguros: "MudeyPRO | Apólices",
  dados: "MudeyPRO | Dados",
  clientes: "MudeyPRO | Clientes",
  "adicionar-cliente": "MudeyPRO | Adicionar Cliente",
  "clientes-detalhes": "MudeyPRO | Detalhe Cliente",
  "formulário-plano": "MudeyPRO | Formulário Plano",
  "configuracoes-marca": "MudeyPRO | Módulo Marca",
  dashboard: "MudeyPRO | Dashboard",
  "editar-membro":"MudeyPRO | Editar Membro",
  "add-user":"MudeyPRO | Adicionar Utilizador",
  "register-contact":"MudeyPRO | Registo Novo Utilizador",
  "seguro-viagem": {
    simulacao: "MudeyPRO | Seguro Viagem | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Viagem | Pagamento",
      comparar: "MudeyPRO | Seguro Viagem | Comparação",
      pacotes: "MudeyPRO | Seguro Viagem | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Viagem | Comparação",
      obrigado: "MudeyPRO | Seguro Viagem | Confirmação Compra",
      beneficiarios: "",
      "thank-you": "MudeyPRO | Seguro Viagem | Confirmação Compra",
      "payment-failure": "",
      "confirmacao-compra": "",
    },
  },

  "seguro-vida-credito": {
    simulacao: "MudeyPRO | Seguro Vida Crédito | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Vida Crédito | Pagamento",
      comparar: "MudeyPRO | Seguro Vida Crédito | Comparação",
      pacotes: "MudeyPRO | Seguro Vida Crédito | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Vida Crédito | Pagamento",
      obrigado: "MudeyPRO | Seguro Vida Crédito | Confirmação Compra",
      beneficiarios: "",
      "thank-you": "MudeyPRO | Seguro Vida Crédito | Confirmação Compra",
      "payment-failure": "",
      "confirmacao-compra": "",
    },
    "calculadora-impacto-spread": {
      questionario:
        "MudeyPRO | Seguro Vida Crédito | Calculadora - Questionário",
      resultados: "MudeyPRO | Seguro Vida Crédito | Calculadora - Resultados",
    },
  },
  "seguro-carro-empresas": {
    simulacao: "MudeyPRO | Seguro Auto Empresas | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Auto Empresas | Pagamento",
      comparar: "MudeyPRO | Seguro Auto Empresas | Comparação",
      pacotes: "MudeyPRO | Seguro Auto Empresas | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Auto Empresas | Pagamento",
      obrigado: "MudeyPRO | Seguro Auto Empresas | Confirmação Compra",
      beneficiarios: "",
      "thank-you": "MudeyPRO | Seguro Auto Empresas | Confirmação Compra",
      "payment-failure": "",
      "confirmacao-compra": "",
    },
  },
  "seguro-carro": {
    simulacao: "MudeyPRO | Seguro Auto | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Auto | Pagamento",
      comparar: "MudeyPRO | Seguro Auto | Comparação",
      "mudeyai-proposta": "MudeyPRO | Seguro Auto | Proposta",
      pacotes: "MudeyPRO | Seguro Auto | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Auto | Pagamento",
      obrigado: "MudeyPRO | Seguro Auto | Confirmação Compra",
      beneficiarios: "",
      "thank-you": "MudeyPRO | Seguro Auto | Confirmação Compra",
      "payment-failure": "",
      "confirmacao-compra": "",
    },
  },
  "seguro-carro-jap": {
    simulacao: "MudeyPRO | Seguro Auto | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Auto | Pagamento",
      comparar: "MudeyPRO | Seguro Auto | Comparação",
      "mudeyai-proposta": "MudeyPRO | Seguro Auto | Proposta",
      pacotes: "MudeyPRO | Seguro Auto | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Auto | Pagamento",
      obrigado: "MudeyPRO | Seguro Auto | Confirmação Compra",
      beneficiarios: "",
      "thank-you": "MudeyPRO | Seguro Auto | Confirmação Compra",
      "payment-failure": "",
      "confirmacao-compra": "",
    },
  },
  "seguro-saude": {
    simulacao: "MudeyPRO | Seguro Saude | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Saude | Pagamento",
      comparar: "MudeyPRO | Seguro Saude | Comparação",
      pacotes: "MudeyPRO | Seguro Saude | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Saude | Pagamento",
      obrigado: "MudeyPRO | Seguro Saude | Confirmação Compra",
      beneficiarios: "",
      "thank-you": "MudeyPRO | Seguro Saude | Confirmação Compra",
      "payment-failure": "",
      "confirmacao-compra": "",
    },
  },
  recibos: "MudeyPRO | Recibos",
  "recibos-detalhes": "MudeyPRO | Recibos | Detalhes",
  sinistros: "MudeyPRO | Sinistros",
  "sinistros-detalhes": "MudeyPRO | Sinistros | Detalhes",
  "participacao-sinistro": "MudeyPRO | Participação de Sinistro",
  "seguro-empregada": {
    simulacao: "MudeyPRO | Seguro Empregada Doméstica | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Empregada Doméstica | Pagamento",
      comparar: "MudeyPRO | Seguro Empregada Doméstica | Comparação",
      pacotes: "MudeyPRO | Seguro Empregada Doméstica | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Empregada Doméstica | Pagamento",
      obrigado: "MudeyPRO | Seguro Empregada Doméstica | Confirmação Compra",
    },
  },
  "seguro-vida": {
    simulacao: "MudeyPRO | Seguro Vida Proteção | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Vida Proteção | Pagamento",
      comparar: "MudeyPRO | Seguro Vida Proteção | Comparação",
      pacotes: "MudeyPRO | Seguro Vida Proteção | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Vida Proteção | Pagamento",
      obrigado: "MudeyPRO | Seguro Vida Proteção | Confirmação Compra",
    },
  },
  "seguro-acidentes-trabalho-independente": {
    simulacao: "MudeyPRO | Seguro AT | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro AT | Pagamento",
      comparar: "MudeyPRO | Seguro AT | Comparação",
      pacotes: "MudeyPRO | Seguro AT | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro AT | Pagamento",
      obrigado: "MudeyPRO | Seguro AT | Confirmação Compra",
    },
  },
  "seguro-acidentes-trabalho-outrem": {
    simulacao: "MudeyPRO | Seguro AT | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro AT | Pagamento",
      comparar: "MudeyPRO | Seguro AT | Comparação",
      pacotes: "MudeyPRO | Seguro AT | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro AT | Pagamento",
      obrigado: "MudeyPRO | Seguro AT | Confirmação Compra",
    },
  },
  "seguro-moto": {
    simulacao: "MudeyPRO | Seguro Moto | Questionário",
    resultados: {
      summary: "MudeyPRO | Seguro Moto | Pagamento",
      comparar: "MudeyPRO | Seguro Moto | Comparação",
      pacotes: "MudeyPRO | Seguro Moto | Resultados",
    },
    compra: {
      pagamento: "MudeyPRO | Seguro Moto | Pagamento",
      obrigado: "MudeyPRO | Seguro Moto | Confirmação Compra",
    },
  },
  "venda-cruzada": "MudeyPRO | Venda Cruzada",
  "venda-cruzada": {
    resultados: "MudeyPRO | Venda Cruzada | Resultados",
    questionario: "MudeyPRO | Venda Cruzada | Questionário",
  },
};

export const titleManager = (location: any): void => {
  // changes the tab label
  if (location && location.pathname) {
    const root = location.pathname.split("/")[1] || "";
    const firstKey = location.pathname.split("/")[2] || "";
    const lastKey = location.pathname.split("/")[3] || "";

    const title = () => {
      if (lastKey) {
        return titles?.[root]?.[firstKey]?.[lastKey] || "MudeyPRO";
      }
      // if (lastKey == "" && firstKey == "pessoa-segura-info") {
      //   return "MUDEY Empresas | Seguro Vida Empresas | Info adicional";
      // }
      // if (firstKey == "" && lastKey == "" && root == "parceria-sodexo") {
      //   return "MUDEY Empresas | Sodexo | Parceria";
      // }
      // if (root == "adicionar-seguros" && firstKey == "" && lastKey == "") {
      //   return "MUDEY Empresas | Adicionar Seguros";
      // }
      if (root == "venda-cruzada" && firstKey == "" && lastKey == "") {
        return "MudeyPRO | Venda Cruzada";
      }
      if (!lastKey && firstKey) {
        return titles?.[root]?.[firstKey] || null;
      }
      if (root && firstKey.length == 0 && lastKey.length == 0) {
        return titles?.[root] || null;
      }
      return null;
    };

    const docTitle = title();

    if (docTitle) {
      document.title = docTitle;
    } else {
      document.title = "MudeyPRO";
    }
  } else {
    document.title = "MudeyPRO";
  }
};
